import React, { useMemo, useState } from "react";
import styled from "styled-components";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    Field,
    FieldFull,
    Req,
    OptLabel,
    SInput,
    IDENTITY_CARDS,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";
import { Dropdown, Flex } from "@fluentui/react-northstar";
import {
    DROPDOWN_COUNTRIES_FORMAT,
    getDataCountryByCode,
} from "../../../constants/countries";
import { ErrorMessage } from "../../../common/styles";

export const WORKING_PERMIT_LIST = ["B", "C", "G", "F", "L"];

export default function BlockInfosPerso() {
    const [avsKnown, setAvsKnown] = useState(true);
    const {
        control,
        setValue,
        formState: { errors },
    } = useFormContext();
    const all_countries = useMemo(() => DROPDOWN_COUNTRIES_FORMAT(), []);

    return (
        <BlockCollab>
            <BlockTitleCollab>
                Informations personnelles
                <BadgeCollab>À compléter par vous</BadgeCollab>
            </BlockTitleCollab>

            <FieldGrid>
                <Field>
                    <label>
                        Nom de jeune fille{" "}
                        <OptLabel>(si différent du nom d'usage)</OptLabel>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Nom de jeune fille"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                />
                            );
                        }}
                        name="personal_infos.birth_name"
                    />
                </Field>

                <FieldFull style={{ display: "block" }}>
                    <AddressLabel>
                        Adresse domicile <Req>*</Req>
                    </AddressLabel>
                    <SubGrid $cols="2fr 1fr">
                        <Field>
                            <label>
                                Rue et numéro <Req>*</Req>
                            </label>
                            <Controller
                                control={control}
                                render={({
                                    field: { onChange, value, name, ref },
                                }) => {
                                    return (
                                        <SInput
                                            placeholder="Ex : 12 rue du Mont"
                                            fluid
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            error={
                                                errors?.personal_infos?.address
                                                    ?.street?.message
                                            }
                                            onChange={(_, i) =>
                                                onChange(i.value)
                                            }
                                        />
                                    );
                                }}
                                name="personal_infos.address.street"
                            />
                            {errors?.personal_infos?.address?.street && (
                                <ErrorMessage
                                    content={
                                        errors?.personal_infos?.address?.street
                                            ?.message
                                    }
                                />
                            )}
                        </Field>
                        {/* code postal */}
                        <Field>
                            <label>
                                Code postal <Req>*</Req>
                            </label>
                            <Controller
                                control={control}
                                render={({
                                    field: { onChange, value, name, ref },
                                }) => {
                                    return (
                                        <SInput
                                            placeholder="Ex : 73000"
                                            fluid
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={(_, i) =>
                                                onChange(i.value)
                                            }
                                            error={
                                                errors?.personal_infos?.address
                                                    ?.postal_code?.message
                                            }
                                        />
                                    );
                                }}
                                name="personal_infos.address.postal_code"
                            />
                            {errors?.personal_infos?.address?.postal_code && (
                                <ErrorMessage
                                    content={
                                        errors?.personal_infos?.address
                                            ?.postal_code?.message
                                    }
                                />
                            )}
                        </Field>
                    </SubGrid>
                    <SubGrid $cols="1fr 1fr" style={{ marginTop: 8 }}>
                        <Field>
                            <label>
                                Ville <Req>*</Req>
                            </label>
                            <Controller
                                control={control}
                                render={({
                                    field: { onChange, value, name, ref },
                                }) => {
                                    return (
                                        <SInput
                                            placeholder="Ex : Genève"
                                            fluid
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            error={
                                                errors?.personal_infos?.address
                                                    ?.city?.message
                                            }
                                            onChange={(_, i) =>
                                                onChange(i.value)
                                            }
                                        />
                                    );
                                }}
                                name="personal_infos.address.city"
                            />
                            {errors?.personal_infos?.address?.city && (
                                <ErrorMessage
                                    content={
                                        errors?.personal_infos?.address?.city
                                            ?.message
                                    }
                                />
                            )}
                        </Field>
                        <Field>
                            <label>
                                Pays <Req>*</Req>
                            </label>
                            <Controller
                                control={control}
                                name="personal_infos.address.country"
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Dropdown
                                            items={all_countries}
                                            value={
                                                all_countries[
                                                    getDataCountryByCode(value)
                                                        ?.index
                                                ]
                                            }
                                            onChange={(_, i) => {
                                                return onChange(
                                                    i?.value?.detail?.code ??
                                                        null
                                                );
                                            }}
                                            error={
                                                errors?.personal_infos?.address
                                                    ?.country?.message
                                            }
                                            clearable
                                            checkable
                                            fluid
                                        />
                                    );
                                }}
                            />
                            {errors?.personal_infos?.address?.country && (
                                <ErrorMessage
                                    content={
                                        errors?.personal_infos?.address?.country
                                            ?.message
                                    }
                                />
                            )}
                        </Field>
                    </SubGrid>
                </FieldFull>

                <Field>
                    <label>
                        Nationalité <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        name="personal_infos.nationality"
                        render={({ field: { onChange, value } }) => (
                            <Dropdown
                                items={all_countries}
                                value={
                                    all_countries[
                                        getDataCountryByCode(value)?.index
                                    ]
                                }
                                error={
                                    errors?.personal_infos?.nationality?.message
                                }
                                onChange={(_, i) => {
                                    return onChange(i?.value?.detail?.code);
                                }}
                                clearable
                                checkable
                                fluid
                            />
                        )}
                    />
                    {errors?.personal_infos?.nationality && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.nationality?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>Permis de travail / séjour</label>
                    <Controller
                        control={control}
                        name="personal_infos.working_permit"
                        render={({ field: { onChange, value } }) => {
                            const findValue =
                                WORKING_PERMIT_LIST.find(
                                    (item) => item === value
                                ) ?? null;
                            return (
                                <Dropdown
                                    placeholder="--"
                                    items={WORKING_PERMIT_LIST}
                                    value={findValue}
                                    onChange={(_, i) => {
                                        return onChange(i?.value ?? null);
                                    }}
                                    error={
                                        errors?.personal_infos?.working_permit
                                            ?.message
                                    }
                                    clearable
                                    checkable
                                    fluid
                                />
                            );
                        }}
                    />
                    {errors?.personal_infos?.working_permit && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.working_permit?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Date de naissance <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="jj.mm.aaaa"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    type="date"
                                    error={
                                        errors?.personal_infos?.birthdate
                                            ?.message
                                    }
                                />
                            );
                        }}
                        name="personal_infos.birthdate"
                    />
                    {errors?.personal_infos?.birthdate && (
                        <ErrorMessage
                            content={errors?.personal_infos?.birthdate?.message}
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Ville de naissance <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Ville de naissance"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.personal_infos?.place_of_birth
                                            ?.message
                                    }
                                />
                            );
                        }}
                        name="personal_infos.place_of_birth"
                    />
                    {errors?.personal_infos?.place_of_birth && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.place_of_birth?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Pays de naissance <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        name="personal_infos.country_of_birth"
                        render={({ field: { onChange, value } }) => (
                            <Dropdown
                                items={all_countries}
                                value={
                                    all_countries[
                                        getDataCountryByCode(value)?.index
                                    ]
                                }
                                onChange={(_, i) => {
                                    return onChange(
                                        i?.value?.detail?.code ?? null
                                    );
                                }}
                                error={
                                    errors?.personal_infos?.country_of_birth
                                        ?.message
                                }
                                clearable
                                checkable
                                fluid
                            />
                        )}
                    />
                    {errors?.personal_infos?.country_of_birth && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.country_of_birth
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Niveau d'études <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="CFC / Bachelor / Master / Doctorat / Autre..."
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.personal_infos?.diploma?.message
                                    }
                                />
                            );
                        }}
                        name="personal_infos.diploma"
                    />
                    {errors?.personal_infos?.diploma && (
                        <ErrorMessage
                            content={errors?.personal_infos?.diploma?.message}
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Caisse-maladie <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Ex : Swica, Helsana, CSS..."
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.personal_infos?.health_insurance
                                    }
                                />
                            );
                        }}
                        name="personal_infos.health_insurance"
                    />
                    {errors?.personal_infos?.health_insurance && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.health_insurance
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Type de pièce d'identité <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        name="personal_infos.identity_card_type"
                        render={({ field: { onChange, value } }) => {
                            return (
                                <Dropdown
                                    items={IDENTITY_CARDS}
                                    placeholder="Choisir ..."
                                    value={IDENTITY_CARDS.find(
                                        (card) => card.id === value
                                    )}
                                    onChange={(_, i) => {
                                        return onChange(i?.value?.id ?? null);
                                    }}
                                    error={
                                        errors?.personal_infos
                                            ?.identity_card_type?.message
                                    }
                                    checkable
                                    fluid
                                    clearable
                                />
                            );
                        }}
                    />
                    {errors?.personal_infos?.identity_card_type && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.identity_card_type
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        N° de pièce d'identité <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Numéro de la pièce"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.personal_infos
                                            ?.identity_card_number?.message
                                    }
                                />
                            );
                        }}
                        name="personal_infos.identity_card_number"
                    />
                    {errors?.personal_infos?.identity_card_number && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos?.identity_card_number
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Fin de validité de la pièce <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="jj.mm.aaaa"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    type="date"
                                    error={
                                        errors?.personal_infos
                                            ?.identity_card_expiry_date
                                    }
                                />
                            );
                        }}
                        name="personal_infos.identity_card_expiry_date"
                    />
                    {errors?.personal_infos?.identity_card_expiry_date && (
                        <ErrorMessage
                            content={
                                errors?.personal_infos
                                    ?.identity_card_expiry_date?.message
                            }
                        />
                    )}
                </Field>
            </FieldGrid>

            <AvsSeparator />
            <AvsLabel>Numéro AVS</AvsLabel>
            <AvsToggle>
                <AvsBtn $active={avsKnown} onClick={() => setAvsKnown(true)}>
                    Je connais mon numéro AVS
                </AvsBtn>
                <AvsBtn
                    $active={!avsKnown}
                    onClick={() => {
                        setValue("personal_infos.avs", "");
                        setAvsKnown(false);
                    }}
                >
                    Je ne connais pas encore mon numéro AVS
                </AvsBtn>
            </AvsToggle>
            {avsKnown ? (
                <Flex column>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="756.XXXX.XXXX.XX"
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    fluid
                                    onChange={(_, i) => {
                                        return onChange(i.value);
                                    }}
                                    maxLength={13}
                                    error={errors?.personal_infos?.avs}
                                    styles={{
                                        maxWidth: "260px",
                                    }}
                                />
                            );
                        }}
                        name="personal_infos.avs"
                    />
                    {errors?.personal_infos?.avs && (
                        <ErrorMessage
                            content={errors.personal_infos.avs.message}
                        />
                    )}
                </Flex>
            ) : (
                <AvsNote>
                    Le numéro AVS sera renseigné ultérieurement par votre
                    responsable RH.
                </AvsNote>
            )}
        </BlockCollab>
    );
}

const SubGrid = styled.div`
    display: grid;
    grid-template-columns: ${({ $cols }) => $cols || "1fr 1fr"};
    gap: 8px;
`;

const AddressLabel = styled.label`
    font-size: 11px;
    color: var(--text-sec);
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 5px;
`;

const AvsSeparator = styled.div`
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid var(--border);
`;

const AvsLabel = styled.label`
    font-size: 11px;
    color: var(--text-sec);
    font-weight: 500;
    display: block;
    margin-bottom: 8px;
`;

const AvsToggle = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
`;

const AvsBtn = styled.div`
    font-size: 12px;
    padding: 6px 13px;
    border-radius: var(--radius-sm);
    border: 1px solid
        ${({ $active }) => ($active ? "var(--blue-mid)" : "var(--border)")};
    cursor: pointer;
    background: ${({ $active }) =>
        $active ? "var(--blue-light)" : "var(--bg-secondary)"};
    color: ${({ $active }) => ($active ? "var(--blue)" : "var(--text-sec)")};
    font-weight: ${({ $active }) => ($active ? 600 : 500)};
    transition: all 0.12s;

    &:hover {
        border-color: var(--blue-mid);
        color: var(--blue);
    }
`;

const AvsNote = styled.div`
    font-size: 12px;
    color: var(--amber);
    margin-top: 6px;
    padding: 8px 12px;
    background: var(--amber-light);
    border-radius: var(--radius-sm);
    border: 1px solid var(--amber-mid);
`;
